// v2/config/locations.config.ts — Indian states and city mapping

// Restricted set — used for lead creation (serviceable areas only)
export const INDIAN_STATES = ['Karnataka', 'Telangana', 'Maharashtra', 'Gujarat', 'Uttar Pradesh', 'Andhra Pradesh', 'Delhi', 'Rajasthan', 'Haryana', 'West Bengal', 'Bihar', 'Punjab', 'Jharkhand', 'Others'];
export const CITY_MAP: Record<string, string[]> = {
  Karnataka: ['Belgaum', 'Bengaluru', 'Davangere', 'Dharwad', 'Hubli', 'Mysuru', 'Tumkur'],
  Telangana: ['Hyderabad', 'Secunderabad', 'Warangal'],
  Maharashtra: ['Kolhapur', 'Mumbai', 'Nagpur', 'Navi Mumbai', 'Pune', 'Thane', 'Latur'],
  Gujarat: ['Ahmedabad', 'Surat', 'Vadodara'],
  'Uttar Pradesh': ['Ghaziabad', 'Noida', 'Lucknow', 'Kanpur', 'Meerut'],
  Haryana: ['Faridabad', 'Gurugram', 'Panipat', 'Sonipat', 'Jind'],
  'Andhra Pradesh': ['Visakhapatnam'],
  Delhi: ['Delhi'],
  Rajasthan: ['Jaipur', 'Udaipur', 'Jodhpur', 'jaisalmer'],
  'West Bengal': ['Kolkata', 'Howrah', 'Asansol', 'Durgapur'],
  Bihar:['Patan', 'Hajipur', 'Gaya', 'Bhagalpur'],
  Punjab:['Chandigarh','Amritsar', 'Ludhiana', 'Jalandhar'],
  Jharkhand: ['Ranchi', 'Jamshedpur'],
  Others: ['Others'],
};

// Full set — used for application address details
export const ALL_INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
];

export const ALL_CITY_MAP: Record<string, string[]> = {
  'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Tirupati', 'Nellore', 'Other'],
  'Arunachal Pradesh': ['Itanagar', 'Other'],
  Assam: ['Guwahati', 'Silchar', 'Dibrugarh', 'Other'],
  Bihar: ['Patna', 'Gaya', 'Muzaffarpur', 'Bhagalpur', 'Other'],
  Chhattisgarh: ['Raipur', 'Bhilai', 'Bilaspur', 'Other'],
  Goa: ['Panaji', 'Margao', 'Vasco da Gama', 'Other'],
  Gujarat: ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Gandhinagar', 'Other'],
  Haryana: ['Gurugram', 'Faridabad', 'Panipat', 'Ambala', 'Karnal', 'Other'],
  'Himachal Pradesh': ['Shimla', 'Manali', 'Dharamshala', 'Other'],
  Jharkhand: ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Other'],
  Karnataka: ['Bengaluru', 'Mysuru', 'Hubli', 'Dharwad', 'Mangaluru', 'Belgaum', 'Tumkur', 'Other'],
  Kerala: ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Other'],
  'Madhya Pradesh': ['Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Other'],
  Maharashtra: ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Navi Mumbai', 'Nashik', 'Aurangabad', 'Other'],
  Manipur: ['Imphal', 'Other'],
  Meghalaya: ['Shillong', 'Other'],
  Mizoram: ['Aizawl', 'Other'],
  Nagaland: ['Kohima', 'Dimapur', 'Other'],
  Odisha: ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Other'],
  Punjab: ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Chandigarh', 'Other'],
  Rajasthan: ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Other'],
  Sikkim: ['Gangtok', 'Other'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Salem', 'Tiruchirappalli', 'Other'],
  Telangana: ['Hyderabad', 'Secunderabad', 'Warangal', 'Karimnagar', 'Other'],
  Tripura: ['Agartala', 'Other'],
  'Uttar Pradesh': ['Lucknow', 'Noida', 'Agra', 'Varanasi', 'Kanpur', 'Ghaziabad', 'Meerut', 'Other'],
  Uttarakhand: ['Dehradun', 'Haridwar', 'Rishikesh', 'Other'],
  'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Siliguri', 'Other'],
  'Andaman and Nicobar Islands': ['Port Blair', 'Other'],
  Chandigarh: ['Chandigarh'],
  'Dadra and Nagar Haveli and Daman and Diu': ['Silvassa', 'Daman', 'Other'],
  Delhi: ['New Delhi', 'Delhi', 'Other'],
  'Jammu and Kashmir': ['Srinagar', 'Jammu', 'Other'],
  Ladakh: ['Leh', 'Kargil', 'Other'],
  Lakshadweep: ['Kavaratti', 'Other'],
  Puducherry: ['Puducherry', 'Other'],
};
